<template>
  <v-app :dark="theme.isDark">
    <div class="app-layout">
      <room-navigation />
      <router-view />
    </div>

    <error-message v-model="errorData" />
    <info-modal />
    <room-info-dialog />
    <confirmation-modal />
  </v-app>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import theme from '@/factories/theme';
import { inIframe, vueEnv } from '@/globals';
import { eventBus } from '@/lib/events';

import initSegment from '@/lib/segment';
import initDataUnlocker from '@/lib/dataUnlocker';

import InfoModal from '@/components/basic/info-modal/InfoModal';
import ErrorMessage from '../helpers/ErrorMessage';
import RoomInfoDialog from '../helpers/RoomInfoDialog';
import ConfirmationModal from '@/components/basic/confirmation-modal/ConfirmationModal';
import RoomNavigation from './RoomNavigation';

export default {
  name: 'RoomsLayout',
  components: {
    ConfirmationModal,
    InfoModal,
    ErrorMessage,
    RoomInfoDialog,
    RoomNavigation,
  },
  data() {
    return {
      theme: theme,
      inIframe,
    };
  },
  computed: {
    ...mapState('rooms', ['roomConfig', 'roomInfo', 'roomError']),
    errorData: {
      get() {
        return this.roomError;
      },
      set(value) {
        this.setRoomError(value);
      },
    },
  },
  watch: {
    roomInfo(info) {
      if (info?.type === 'guest') {
        this.updateMobileBreakpoints(['xs', 'sm']);
      }

      if (info?.type === 'host' && !window.Beacon) {
        this.installHelpScoutBeacon();
      }
    },
  },
  methods: {
    ...mapActions(['updateMobileBreakpoints']),
    ...mapMutations('rooms', ['setRoomError']),

    checkNavigator() {
      if (!navigator.mediaDevices) {
        eventBus.trigger('showRoomInfoDialog', { type: 'getUserMedia' });
      }
    },

    installHelpScoutBeacon() {
      !(function (e, t, n) {
        function a() {
          var e = t.getElementsByTagName('script')[0],
            n = t.createElement('script');
          (n.type = 'text/javascript'),
            (n.async = !0),
            (n.src = 'https://beacon-v2.helpscout.net'),
            e.parentNode.insertBefore(n, e);
        }
        if (
          ((e.Beacon = n =
            function (t, n, a) {
              e.Beacon.readyQueue.push({ method: t, options: n, data: a });
            }),
          (n.readyQueue = []),
          'complete' === t.readyState)
        )
          return a();
        e.attachEvent
          ? e.attachEvent('onload', a)
          : e.addEventListener('load', a, !1);
      })(window, document, window.Beacon || function () {});

      this.initBeacon();
    },

    initBeacon() {
      let attempt = 0;
      const LIMIT = 20;

      let checker = setInterval(() => {
        if (window.Beacon || attempt > LIMIT) {
          if (window.Beacon) {
            window.Beacon('init', 'bcf8fb2f-aa17-475e-a5ee-0ad44774fde1');
            window.Beacon('config', { color: '#1bc0af' });
            this.identifyBeacon();
            this.addBeaconClickListener();
          }
          clearInterval(checker);
        }

        attempt += 1;
      }, 100);
    },

    async identifyBeacon() {
      await this.$nextTick();

      if (!this.roomInfo || !window.Beacon) return;

      const { id, name, avatar, on, room } = this.roomInfo;

      const beaconInfo = {
        id,
        room,
        name,
        officeNumber: on,
      };

      if (avatar) {
        beaconInfo.avatar = avatar;
      }

      window.Beacon('identify', beaconInfo);
    },

    addBeaconClickListener() {
      Beacon('on', 'open', () => {
        this.toggleClickOutsideListener(true);
      });

      Beacon('on', 'close', () => {
        this.toggleClickOutsideListener(false);
      });
    },

    toggleClickOutsideListener(listen = false) {
      let method = listen ? 'addEventListener' : 'removeEventListener';
      window[method]('click', () => Beacon('close'));
    },

    initAnalytics() {
      const segmentKey = vueEnv('vector_apex_segment_key');
      if (segmentKey) {
        initSegment(segmentKey);
      }
    },
  },
  created() {
    initDataUnlocker();
    this.updateMobileBreakpoints(['xs']);
    this.initAnalytics();
    setTimeout(() => {
      this.checkNavigator();
    });
  },
};
</script>
